import React, { useState } from "react";

import Select from "react-select";
import "../../../PanelGerarRelatorios/index.css";
import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  getDowloadConfiguracaoPorGleba,
  getSafras,
  getTipoSafra,
  getProdutor,
  getFazenda,
} from "../../../../../Services/programation.service";
export const RelatorioPorGleba = () => {
  const [selectOption, setSelectOption] = useState({
    tiposSafra: [],
    safras: [],
    produtores: [],
  });
  const getTipoSafrafetch = async () => {
    const { res } = await getTipoSafra();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((tipoSafra) => !tipoSafra.excluido)
        .map((tipoSafra) => ({
          label: tipoSafra.nome,
          value: tipoSafra.id,
        }));
    }
    return [];
  };

  const getSafrasfetch = async () => {
    const { res } = await getSafras();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((safra) => !safra.excluido)
        .map((safra) => ({
          label: safra.nome,
          value: safra.id,
        }));
    }
    return [];
  };
  const getProdutorFetch = async () => {
    const { res } = await getProdutor();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((produtor) => !produtor.excluido)
        .map((produtor) => ({
          label: produtor.nome,
          value: produtor.id,
        }));
    }
    return [];
  };
  const getFazendasfetchAgrupado = async () => {
    const { res } = await getFazenda(selectOption?.produtor?.produtorId);
    if (res?.data) {
      const { data } = res;
      return data
        .filter((fazenda) => !fazenda.excluido)
        .map((fazenda) => ({
          label: fazenda.nome,
          value: fazenda.id,
        }));
    }
    return [];
  };

  const handleSelectChangeSafra = (name, label) => {
    return (option) => {
      let safra = safrasQuery.data;
      safra = {
        ...safra,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        safra,
      }));
    };
  };
  const handleSelectChangeFazenda = (name, label) => {
    return (option) => {
      let fazenda = fazendaQueryAgrupado.data;
      fazenda = {
        ...fazenda,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        fazenda,
      }));
    };
  };
  const handleSelectChangeTipoSafra = (name, label) => {
    return (option) => {
      let tipoSafra = tiposSafraQuery.data;
      tipoSafra = {
        ...tipoSafra,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        tipoSafra,
      }));
    };
  };
  const handleSelectChangeProdutor = (name, label) => {
    return (option) => {
      let produtor = produtoresQuery.data;
      produtor = {
        ...produtor,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        produtor,
      }));
    };
  };

  const tiposSafraQuery = useQuery(["tiposSafraQuery"], getTipoSafrafetch, []);
  const safrasQuery = useQuery(["safrasQuery"], getSafrasfetch, []);
  const produtoresQuery = useQuery(["produtoresQuery"], getProdutorFetch, []);
  const fazendaQueryAgrupado = useQuery(
    ["fazendaQueryAgrupado", selectOption?.produtor?.produtorId],
    getFazendasfetchAgrupado,
    []
  );

  // Limpa caracteres que não podem ir num nome de arquivo (/ \ : * ? " < > |)
  const limpaNome = (t) =>
    String(t || "")
      .replace(/[\\/:*?"<>|]/g, "-")
      .trim();

  const handleDownloadGleba = async () => {
    // A FAZENDA é opcional: deixando em branco, saem todas as fazendas do produtor.
    if (
      !selectOption?.produtor?.produtorId ||
      !selectOption?.safra?.safraId ||
      !selectOption?.tipoSafra?.tipoSafraId
    ) {
      toast.warning(
        "Escolha produtor, safra e tipo de safra. (Deixe a fazenda em branco para sair todas.)"
      );
      return;
    }
    const { res, mensagem } = await getDowloadConfiguracaoPorGleba(
      selectOption.tipoSafra.tipoSafraId,
      selectOption.safra.safraId,
      selectOption?.fazenda?.fazendaId,
      selectOption.produtor.produtorId
    );
    // Sem programação o servidor responde explicando o motivo. Antes o código
    // usava res.data direto e quebrava, mostrando "erro" sem dizer o porquê.
    if (!res?.data) {
      toast.warning(mensagem || "Não foi possível gerar o relatório.");
      return;
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    // Nome do arquivo: Produtor_Fazenda_Safra_TipoSafra (o que estiver preenchido)
    const partes = [
      selectOption?.produtor?.produtorLabel,
      // sem fazenda escolhida, deixa claro no nome que saiu tudo
      selectOption?.fazenda?.fazendaId
        ? selectOption?.fazenda?.fazendaLabel
        : "Todas as Fazendas",
      selectOption?.safra?.safraLabel,
      selectOption?.tipoSafra?.tipoSafraLabel,
    ]
      .filter(Boolean)
      .map(limpaNome)
      .join("_");
    link.setAttribute(
      "download",
      (partes ? "Programacao_por_gleba_" + partes : "Programacao_por_gleba") +
        ".pdf"
    );
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="generating-container-reports">
      <div className="reports-content">
        <h6
          style={{
            fontWeight: "bold",
            color: "rgba(1, 104, 32, 0.81)",
            marginBottom: "10px",
          }}
        >
          Relatório por gleba
        </h6>
        <div className="select-reports">
          <div className="select-content-relatorio-agrupado">
            Selecione o Produtor
            <Select
              defaultValue={{}}
              onChange={handleSelectChangeProdutor("produtorId", "produtorLabel")}
              options={produtoresQuery.data}
            />
          </div>
          <div className="select-content-relatorio-agrupado">
            Selecione a Fazenda
            <div style={{ fontSize: "11px", color: "#666", fontStyle: "italic" }}>
              em branco = todas
            </div>
            <Select
              defaultValue={{}}
              onChange={handleSelectChangeFazenda("fazendaId", "fazendaLabel")}
              options={fazendaQueryAgrupado.data}
              isDisabled={!selectOption?.produtor?.produtorId}
            />
          </div>
          <div className="select-content-relatorio-agrupado">
            Selecione a Safra
            <Select
              defaultValue={{}}
              onChange={handleSelectChangeSafra("safraId", "safraLabel")}
              options={safrasQuery.data}
              isDisabled={!selectOption?.produtor?.produtorId}
            />
          </div>
          <div className="select-content-relatorio-agrupado">
            Selecione o Tipo Safra
            <Select
              defaultValue={{}}
              onChange={handleSelectChangeTipoSafra("tipoSafraId", "tipoSafraLabel")}
              options={tiposSafraQuery.data}
              isDisabled={!selectOption?.produtor?.produtorId}
            />
          </div>
        </div>
        <Button
          className="button-generate-reports"
          variant="danger"
          size="lg"
          onClick={handleDownloadGleba}
        >
          Gerar Relatório
        </Button>
      </div>
    </div>
  );
};
